"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelKey = exports.getQueryKey = void 0;
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
function getQueryKey(query) {
    if (typeof query === "string") {
        return query;
    }
    const { model, params } = query;
    const paramsStr = params === undefined ? "" : fast_json_stable_stringify_1.default(params);
    return `${model.key}(${paramsStr})`;
}
exports.getQueryKey = getQueryKey;
function getModelKey(query) {
    if (typeof query === "string") {
        const i = query.indexOf("(");
        return query.substring(0, i);
    }
    return query.model.key;
}
exports.getModelKey = getModelKey;
